import { render, staticRenderFns } from "./FooterForUpdate.vue?vue&type=template&id=792a5909&scoped=true&"
import script from "./FooterForUpdate.vue?vue&type=script&lang=js&"
export * from "./FooterForUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FooterForUpdate.vue?vue&type=style&index=0&id=792a5909&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792a5909",
  null
  
)

export default component.exports